import styled from 'styled-components';
import { Breadcrumbs, FlexColumn } from '@elementary/common-ui/components';
import { space } from '@elementary/common-ui/style/utils';
import useIsBoomiLookEnabled from 'shared/hooks/useIsBoomiLookEnabled';
import Display from './Display';
import Password from './Password';
import PersonalInfo from './PersonalInfo';

const Wrapper = styled(FlexColumn)`
  width: 100%;
  gap: ${space('xxl')};
`;

const PersonalSettings = () => {
  const isBoomiLookEnabled = useIsBoomiLookEnabled();

  return (
    <Wrapper>
      <Breadcrumbs
        items={['User', 'Personal settings']}
        showTreeButton={false}
      />
      <PersonalInfo />
      <Password />
      {isBoomiLookEnabled && <Display />}
    </Wrapper>
  );
};

export default PersonalSettings;
